import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import { NormalStockI, NormalStockPriceI } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import StockBankruptcyItem from "./StockBankruptcyItem";
import StockBuyPrefab from "./StockBuyPrefab";
import StockItem from "./StockItem";
import StockSellItem from "./StockSellItem";
import StockSellPrefab from "./StockSellPrefab";

const { ccclass, property } = cc._decorator;

@ccclass
export default class StockPutInPrefab extends cc.Component {
    @property({ type: cc.Node, displayName: "中心节点" })
    centerNode: cc.Node = null;

    @property({ type: cc.Prefab, displayName: "股票买入item预制体" })
    stockItem: cc.Prefab = null;

    @property({ type: cc.Prefab, displayName: "股票卖出item预制体" })
    stockSellItem: cc.Prefab = null;

    @property({ type: cc.Prefab, displayName: "股票购买UI预制体" })
    stockBuyPrefab: cc.Prefab = null;

    @property({ type: cc.Prefab, displayName: "股票卖出UI预制体" })
    stockSellPrefab: cc.Prefab = null;

    @property({ type: cc.Prefab, displayName: "股票破产item预制体" })
    stockBankruptcyItem: cc.Prefab = null;

    @property({ type: cc.Node, displayName: "购买标题" })
    buyTitle: cc.Node = null;

    @property({ type: cc.Node, displayName: "卖出标题" })
    sellTitle: cc.Node = null;

    @property({ type: cc.Node, displayName: "内容节点" })
    contentNode: cc.Node = null;

    @property({ type: cc.Node, displayName: "展示股市按钮" })
    putInStock: cc.Node = null;

    @property({ type: cc.Node, displayName: "展示已有股票按钮" })
    sellStock: cc.Node = null;

    static OPEN_BUY_STOCK_PREFAB: string = "OPEN_BUY_STOCK_PREFAB"
    static OPEN_SELL_STOCK_PREFAB: string = "OPEN_SELL_STOCK_PREFAB"
    static CHANGE_STOCK_COUNT: string = "CHANGE_STOCK_COUNT"
    static REST_STOCK_MESSAGE: string = "REST_STOCK_MESSAGE"

    itemNode: cc.NodePool = new cc.NodePool
    sellItemNode: cc.NodePool = new cc.NodePool
    bankruptcyItemNode: cc.NodePool = new cc.NodePool
    start() {
        this.onRestStockBtn(false, false);
        O1HD.on(StockPutInPrefab.OPEN_BUY_STOCK_PREFAB, this.onOpenStockBuyPrefab, this);
        O1HD.on(StockPutInPrefab.OPEN_SELL_STOCK_PREFAB, this.onOpenStockSellPrefab, this);
        O1HD.on(StockPutInPrefab.CHANGE_STOCK_COUNT, this.onChangeStockCount, this);
        O1HD.on(StockPutInPrefab.REST_STOCK_MESSAGE, this.onRestStockBtn, this);
        this.onLoadPoolNode()
        //进入基金界面的天数
        let day = Math.floor(NormalGameManager._instance.mGameHours / 24)
        this.schedule(() => {
            let nowDay = Math.floor(NormalGameManager._instance.mGameHours / 24)
            if (nowDay != day) {
                this.onRestStockBtn(false, false);
                day = nowDay
            }
        }, 1)
    }

    onChangeStockCount(isBuy: boolean = true) {
        if (isBuy) {
            this.onPutInStockBtn();
        } else {
            this.onSellStockBtn();
        }
    }

    onOpenStockBuyPrefab(stockPrice: NormalStockPriceI, isBuy: boolean = false) {
        let stockBuy = cc.instantiate(this.stockBuyPrefab);
        stockBuy.getComponent(StockBuyPrefab).bindData(stockPrice, isBuy);
        O1HD.Canvas().addChild(stockBuy);
    }

    onOpenStockSellPrefab(stockPrice: NormalStockPriceI, stock: NormalStockI) {
        let stockSell = cc.instantiate(this.stockSellPrefab);
        stockSell.getComponent(StockSellPrefab).bindData(stockPrice, stock);
        O1HD.Canvas().addChild(stockSell);
    }

    onPutInStockBtn() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.buyTitle.active = true;
        this.sellTitle.active = false;
        this.sellStock.color = new cc.Color(0, 0, 0);
        this.putInStock.color = new cc.Color(255, 255, 255);
        this.contentNode.removeAllChildren();
        // this.onRecycleItemNode();
        let stockPriceArray = NormalGameManager._instance.getGameData().stockPriceArray;
        for (let index = 0; index < stockPriceArray.length; index++) {
            if (stockPriceArray[index].count > 0) {
                //破产后不展示信息
                if (stockPriceArray[index].bankruptcy > 0) {
                    // let item = cc.instantiate(this.stockBankruptcyItem);
                    let item;
                    if (this.bankruptcyItemNode.size() > 0) {
                        item = this.bankruptcyItemNode.get();
                    } else {
                        let newNode = cc.instantiate(this.stockBankruptcyItem);
                        this.bankruptcyItemNode.put(newNode);
                        item = this.bankruptcyItemNode.get();
                    }
                    item.getComponent(StockBankruptcyItem).bindData(stockPriceArray[index]);
                    this.contentNode.addChild(item);
                } else {
                    let item;
                    if (this.itemNode.size() > 0) {
                        item = this.itemNode.get();
                    } else {
                        let newNode = cc.instantiate(this.stockItem);
                        this.itemNode.put(newNode);
                        item = this.itemNode.get();
                    }
                    item.getComponent(StockItem).bindData(stockPriceArray[index]);
                    this.contentNode.addChild(item);
                }
            }
        }
    }

    onSellStockBtn() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.buyTitle.active = false;
        this.sellTitle.active = true;
        this.putInStock.color = new cc.Color(0, 0, 0);
        this.sellStock.color = new cc.Color(255, 255, 255);
        this.contentNode.removeAllChildren();
        // this.onRecycleItemNode();
        let stockArray = NormalGameManager._instance.getGameData().stockArray;
        let stockPriceArray = NormalGameManager._instance.getGameData().stockPriceArray;
        for (let index = 0; index < stockArray.length; index++) {
            let item;
            if (this.sellItemNode.size() > 0) {
                item = this.sellItemNode.get();
            } else {
                let newNode = cc.instantiate(this.stockSellItem);
                this.sellItemNode.put(newNode);
                item = this.sellItemNode.get();
            }
            // let item = cc.instantiate(this.stockSellItem);
            stockPriceArray.forEach(element => {
                if (stockArray[index].id == element.id) {
                    item.getComponent(StockSellItem).bindData(element, stockArray[index]);
                }
            });
            this.contentNode.addChild(item);
        }
    }

    onLoadPoolNode() {
        this.schedule(() => {
            if (this.itemNode.size() < 30) {
                let newNode = cc.instantiate(this.stockItem);
                this.itemNode.put(newNode)
            }
            if (this.sellItemNode.size() < 30) {
                let newNode = cc.instantiate(this.stockSellItem);
                this.sellItemNode.put(newNode)
            }
            if (this.bankruptcyItemNode.size() < 30) {
                let newNode = cc.instantiate(this.stockBankruptcyItem);
                this.bankruptcyItemNode.put(newNode)
            }
        }, 0.05)
    }

    onRestStockBtn(isChangePrice: boolean = true, isVideo: boolean = true) {
        if (isVideo) {
            utilsModel.loadAndShowVideoAdTrans(() => {
                NormalGameManager._instance.onStockPriceChange(() => {
                    if (this.buyTitle.active) {
                        this.onPutInStockBtn();
                    } else {
                        this.onSellStockBtn();
                    }
                }, isChangePrice);
            }, () => { }, null, "看广告刷新基金");
        } else {
            NormalGameManager._instance.onStockPriceChange(() => {
                if (this.buyTitle.active) {
                    this.onPutInStockBtn();
                } else {
                    this.onSellStockBtn();
                }
            }, isChangePrice);
        }
    }

    onRestBtn() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.onRestStockBtn();
    }

    onCloseBtn() {
        O1HD.off(StockPutInPrefab.OPEN_BUY_STOCK_PREFAB);
        O1HD.off(StockPutInPrefab.OPEN_SELL_STOCK_PREFAB);
        O1HD.off(StockPutInPrefab.OPEN_SELL_STOCK_PREFAB);
        O1HD.off(StockPutInPrefab.REST_STOCK_MESSAGE);
        cc.tween(this.centerNode).to(.5, { scale: 0 }, { easing: cc.easing.backIn }).call(() => {
            this.node.destroy();
        }).start();
    }

}
